export default "__VITE_ASSET__BEogRWme__"